import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: end;
        padding: 54px 28px;
        gap: 24px;

        & > img {
            width: 100%;
        }

        & > p {
            ${({ theme }) => theme.font["small-regular"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,

    "ImgList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
}